import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";


export const defaultTypes: any = {
    theme: {
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },
        dropdownButton: {
            padding: GlobalTokens.SpacingInsetSizeNano
        },
        dropdownButtonName: {
            fontFamily: BrandTokens.FontFamily,
            fontWeight: BrandTokens.FontWeightMedium,
            fontSize: GlobalTokens.FontSizeXs,
            lineHeight: GlobalTokens.LineHeightDefault,
            color: BrandTokens.NeutralColorLowDark,
            paddingBottom: GlobalTokens.SpacingSizeNano
        },
        dropdownButtonAccount: {
            fontFamily: BrandTokens.FontFamily,
            fontWeight: BrandTokens.FontWeightRegular,
            fontSize: GlobalTokens.FontSizeXxs,
            lineHeight: GlobalTokens.LineHeightDefault,
            color: BrandTokens.NeutralColorLowDark,
        },
        dropdownButtonAvatar: {
            paddingRight: GlobalTokens.SpacingSizeXxxs
        },
        dropdownButtonIcon: {
            paddingLeft: GlobalTokens.SpacingSizeXxs
        },
        dropdown: {
            backgroundColor: BrandTokens.NeutralColorHighPure,
            boxShadow: `${GlobalTokens.ShadowLevel2} ${hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelLight)}`,
            borderRadius: GlobalTokens.BorderRadiusMd,
            mobile: {
                width: '100vw',
                height: '100vh',
            }
        },
        dropdownList: {
            tablet: {
                padding: GlobalTokens.SpacingInsetSizeXs,
                marginTop: GlobalTokens.SpacingSizeNano
            }
        },
    }
}